import { render, staticRenderFns } from "./competitive.vue?vue&type=template&id=33be5e24&scoped=true&"
import script from "./competitive.vue?vue&type=script&lang=js&"
export * from "./competitive.vue?vue&type=script&lang=js&"
import style0 from "./competitive.vue?vue&type=style&index=0&id=33be5e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be5e24",
  null
  
)

export default component.exports